import { getPageByBookIdQuery } from "./queries";
const token = "19e6a10517d71506301bfdb0586869";

export const getBook = async (
  slug: string
): Promise<{ status: number; data }> => {
  try {
    const data = await fetch("https://graphql.datocms.com/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query: getPageByBookIdQuery(slug),
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.errors) {
          // eslint-disable-next-line no-console
          console.log("❗️❗️❗️❗️", JSON.stringify(res.errors, null, 2));
          return new Error("Error fetching content");
        }
        return res.data;
      });

    if (data) {
      // eslint-disable-next-line no-console
      return { status: 200, data: data };
    } else {
      return { status: 404, data: null };
    }
  } catch (err) {
    throw new Error("data not fetched");
  }
};
